import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  OnInit,
  output,
  signal,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { WarningIconComponent } from '@kuiper/icons';
import { RichEditorDualLangTextAreaComponent } from '../../../../../../ui-components/lib/rich-editor-dual-lang-text-area/rich-editor-dual-lang-text-area.component';

@Component({
  selector: 'lib-hold-resume-modal',
  imports: [
    ReactiveFormsModule,
    TranslocoPipe,
    RichEditorDualLangTextAreaComponent,
    WarningIconComponent,
  ],
  templateUrl: './hold-resume-modal.component.html',
  styleUrl: './hold-resume-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class HoldResumeModalComponent implements OnInit {
  translocoService = inject(TranslocoService);
  fb = inject(FormBuilder);
  closeModal = output<void>();
  submitHoldResume = output<any>();
  isCommentRequired = input<boolean>(false);
  holdResumeForm = signal<FormGroup>(
    this.fb.group({
      comment: ['', []],
    })
  );

  ngOnInit(): void {
    if (this.isCommentRequired()) {
      this.holdResumeForm()
        .get('comment')
        ?.addValidators([Validators.required]);
    }
  }

  onSubmit(): void {
    if (this.holdResumeForm().valid) {
      const formValue = this.holdResumeForm().getRawValue();
      this.submitHoldResume.emit(formValue);
    } else {
      this.holdResumeForm().markAsDirty();
      this.holdResumeForm().markAllAsTouched();
    }
  }

  onClose(): void {
    this.closeModal.emit();
  }
}
